export default "__VITE_ASSET__2aPOekOw__"